const $ = jQuery.noConflict();
import '@fancyapps/fancybox';

'use strict';
const Fancybox = {
	/**
	 * @description Cache dom and strings
	 * @type {object}
	 */

	$domSlidePopupOpener: $('.js-slider-side__item-textual'),

	/** @description Initialize */
	init: function() {
		this.fancyboxPopup('.js-popup-trigger', '.js-popup', 'popup-custom-class');
		this.fancyboxPopup('.site-footer__box-link--media', '.js-popup-video', 'popup-custom-class');
		$('.js-video-holder__all-icon').on('click', function() {
			$('.fancybox-close-small').trigger('click');
		});

		Fancybox.$domSlidePopupOpener.each((i, el)=> {
			const popup = $(el).parent().find('.js-slider-side__item-popup');
			Fancybox.fancyboxPopup(el, popup);
		});
	},

	/**
	 * @description Fancy box custom popup functionality.
	 * @link documentation https://fancyapps.com/fancybox/3/docs/#inline
	 * @example this.functions.fancyboxPopup('.popup-btn', '.popup', 'my-custom-class');
	 * @param {string} trigger - popup trigger
	 * @param {string} popup - popup wrapper class
	 * @param {string} customClass - custom class for each popup (optional)
	 */
	fancyboxPopup: (trigger, popup, customClass = '') => {
		$(trigger).fancybox({
			src: popup,
			type: 'inline',
			smallBtn: true,
			baseClass: customClass,

			afterShow: function() {
				if($('.slider-side__image-img').length > 0) {
					$('.slider-side__image-img').addClass('popup-image-rotate');
				}
			},

			afterClose: function() {
				if($('.slider-side__image-img').length > 0) {
					$('.slider-side__image-img').removeClass('popup-image-rotate');
				}
			},
		});
	}
};

export default Fancybox;
